import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getAccounting } from './accounting.selectors';

const selectWarehouses = createSelector(getAccounting, ({ warehouses }) => warehouses);

export const selectWarehousesValues = createSelector(selectWarehouses, Object.values);

export const selectWarehouseBankOptions = createSelector(selectWarehousesValues, warehouses =>
  warehouses.map(warehouse => ({ value: warehouse.warehouseBankId, name: warehouse.name })),
);

export const selectFilteredWarehouseBanks = createSelector(
  getDebouncedSearchValue,
  selectWarehousesValues,
  searchItems(warehouse => [warehouse.name]),
);
